import { createWebHistory, createRouter, createWebHashHistory } from "vue-router";

import EcommercePage from "../pages/Dashboard/EcommercePage.vue";
import LMSCoursesPage from "../pages/Dashboard/LMSCoursesPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import EmailConfirmationPage from "../pages/Authentication/EmailConfirmationPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import MaintenancePage from "../pages/PagesInner/MaintenancePage.vue";
import ConnectedAccountsPage from "../pages/PagesInner/ConnectedAccountsPage.vue";
import LogoutPage from "../pages/LogoutPage.vue";
import ListePermissionPage from "@/pages/Permission/ListePermissionPage.vue";
import AddAttributionPage from "@/pages/Attribution/AddAttributionPage.vue";
import ListeAttributionPage from "@/pages/Attribution/ListeAttributionPage.vue";
import AddRolePage from "@/pages/Role/AddRolePage.vue";
import ListeArrieresContratPage from "@/pages/ArrieresContrat/ListeArrieresContratPage.vue";
import EditRolePage from "@/pages/Role/EditRolePage.vue";
import ListeRolePage from "@/pages/Role/ListeRolePage.vue";
import DetailRetourPage from "@/pages/Retour/DetailRetourPage.vue";
import DetailAttributionPage from "@/pages/Attribution/DetailAttributionPage.vue";
import ListeRetourPage from "@/pages/Retour/ListeRetourPage.vue";
import AddRetourPage from "@/pages/Retour/AddRetourPage.vue";
import ViewRolePage from "@/pages/Role/ViewRolePage.vue";
import PaiementPage from "@/pages/Paiement/PaiementPage.vue";

import PaiementAmbulantPage from "@/pages/PaiementAmbulant/PaiementAmbulantPage.vue";
import AddUserPage from "@/pages/Users/AddUserPage.vue";
import EditUserPage from "@/pages/Users/EditUserPage.vue";
import ListeUserPage from "@/pages/Users/ListeUserPage.vue";
import ListeArriresPage from "@/pages/Arrires/ListeArrieresPage.vue";
import ProfilePage from "../pages/PagesInner/ProfilePage.vue";
import ListeJournalConnexionPage from "@/pages/Journal/ListeJournalConnexionPage.vue";
import ListeJournalOperationPage from "@/pages/Journal/ListeJournalOperationPage.vue";

import { useAuthStore } from "@/services/auth";
import ApiService from "@/services/ApiService";
import EditRetourPage from "@/pages/Retour/EditRetourPage.vue";
import ListePaiementPage from "@/pages/Paiement/ListePaiementPage.vue";
import ListePaiementAnnulesPage from "@/pages/Paiement/ListePaiementAnnulesPage.vue";
import ListePaiementAmbulantPage from "@/pages/PaiementAmbulant/ListePaiementAmbulantPage.vue";
import UsagerPaiementPage from "@/pages/Paiement/UsagerPaiementPage.vue";
import ProcessPaiement from "@/pages/Paiement/ProcessPaiement.vue";
import ListeUsagerEmplacementDetailPage from "@/pages/Emplacement/ListeUsagerEmplacementDetailPage.vue";
import ListeEmplacementPage from "@/pages/Emplacement/ListeEmplacementPage.vue";
import AddEmplacementPage from "@/pages/Emplacement/AddEmplacementPage.vue";
import ViewEmplacementPage from "@/pages/Emplacement/ViewEmplacementPage.vue";
import DetailPage from "@/pages/Usagers/DetailPage.vue";
import ListePaiementUsagerPage from "@/pages/Paiement/ListePaiementUsagerPage.vue";
import ListeUsagerPage from "@/pages/Usagers/ListeUsagerPage.vue";
import PaiementRegularisationPage from "@/pages/Paiement/PaiementRegularisationPage.vue";
import PaiementAutreRecettesPage from "@/pages/Paiement/PaiementAutreRecettesPage.vue";
import ListeSecteurPage from "@/pages/Emplacement/ListeSecteurPage.vue";
import ListePaiementAutreRecettePage from "@/pages/Paiement/ListePaiementAutreRecettePage.vue";
import StatistiquePage from "@/pages/Statistique/StatistiquePage.vue";
import RecensementUsager from "@/pages/RecensementUsager.vue";
import RecensementForm from "@/pages/Recensement/RecensementFormPage.vue";
import ListeVerificationPage from "@/pages/Verification/ListeVerificationPage.vue";
import ListeRecensementPage from "@/pages/Recensement/ListeRecensementPage.vue";
import RecensementDashboard from "@/pages/Dashboard/RecensementDashboardPage.vue";
import FicheRecensementPage from "@/pages/FicheRecensement/FicheRecensementPage.vue";
import EtatUsagersPage from "@/pages/Etats/EtatUsagersPage.vue";
import EtatPlacesArrieresPage from "@/pages/Etats/EtatPlacesArrieresPage.vue";
import AddContratPage from "@/pages/Contrat/AddContratPage.vue";
import ListeContratPage from "@/pages/Contrat/ListeContratPage.vue";
import MutationContratPage from "@/pages/Contrat/MutationContratPage.vue";
import ListeTypeRecettePage from "@/pages/Parametres/ListeTypeRecettePage.vue";
import ListeMarchePage from "@/pages/Parametres/ListeMarchePage.vue";
import ListeZonePage from "@/pages/Parametres/ListeZonePage.vue";
import ListeSecteurParametresPage from "@/pages/Parametres/ListeSecteurParametresPage.vue";
import ListeModePaiementPage from "@/pages/Parametres/ListeModePaiementPage.vue";

const routes = [
  {
    path: "/",
    redirect: "/e-paiement",
    component: () => import("@/layouts/LandingV.vue"),
    children: [
      {
        path: "/e-paiement",
        name: "UsagerPaiementPage",
        component: UsagerPaiementPage,
      },
      {
        path: "/e-processus",
        name: "ProcessusPaiement",
        component: ProcessPaiement,
      },
    ],
  },
  {
    path: "/",
    redirect: "/tableau_bord",
    component: () => import("@/layouts/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      
      {
        path: "/tableau_bord",
        name: "DashboardPage",
        component: EcommercePage,
      },     
      {
        path: "/tableau_bord1",
        name: "tableauBordPage1",
        component: LMSCoursesPage,
      },
      {
        path: "/liste-privileges",
        name: "ListePermissionPage",
        component: ListePermissionPage,
      },
      {
        path: "/liste-usager",
        name: "ListeUsagerPage",
        component: ListeUsagerPage,
      },
      {
        path: "/detail-usager/:id",
        name: "DetailUsagerPage",
        component: DetailPage,
      },
      {
        path: "/liste-emplacement",
        name: "ListeEmplacementPage",
        component: ListeEmplacementPage,
      },

      {
        path: "/ajouter-emplacement",
        name: "AddEmplacementPage",
        component: AddEmplacementPage,
      },
      {
        path: "/detail-emplacement/:id?",
        name: "ViewEmplacementPage",
        component: ViewEmplacementPage,
      },
      {
        path: "/liste-paiement",
        name: "ListePaiementPage",
        component: ListePaiementPage,
      },
      {
        path: "/liste-autre-recette",
        name: "ListePaiementAutreRecettePage",
        component: ListePaiementAutreRecettePage,
      },
      {
        path: "/liste-secteur",
        name: "ListeSecteurPage",
        component: ListeSecteurPage,
      },
      {
        path: "/ajouter-paiement-recette",
        name: "PaiementAutreRecettesPage",
        component: PaiementAutreRecettesPage,
      },
      {
        path:"/liste-usager-emplacement-detail",
        name: "ListeUsagerEmplacementDetailPage",
        component: ListeUsagerEmplacementDetailPage,
      },
      {
        path: "/liste-paiement-annules",
        name: "ListePaiementAnnulesPage",
        component: ListePaiementAnnulesPage,
      },
      {
        path: "/point-usagers",
        name: "ListePaiementUsagerPage",
        component: ListePaiementUsagerPage,
      },
      {
        path: "/regularisation-paiement",
        name: "PaiementRegularisationPage",
        component: PaiementRegularisationPage,
      },
      {
        path: "/liste-paiement-ambulant",
        name: "ListePaiementAmbulantPage",
        component: ListePaiementAmbulantPage,
      },
      {
        path: "/paiement-ambulant",
        name: "PaiementAmbulantPage",
        component: PaiementAmbulantPage,
      },
      { 
        path: "/ajouter-role",
        name: "AddRolePage",
        component: AddRolePage,
      },
      { 
        path: "/liste_arrieres",
        name: "ListeArriresPage",
        component: ListeArriresPage,
      },
      { 
        path: "/liste_contrats_arrieres",
        name: "ListeArrieresContratPage",
        component: ListeArrieresContratPage,
      },
      { 
        path: "/detail_retour/:id?",
        name: "DetailRetourPage",
        component: DetailRetourPage,
      },
      { 
        path: "/detail_attribution/:id?",
        name: "DetailAttributionPage",
        component: DetailAttributionPage,
      },
      { 
        path: "/paiement",
        name: "PaiementPage",
        component: PaiementPage,
      },
      {
        path: "/modifier-role/:id",
        name: "EditRolePage",
        component: EditRolePage,
      },
      {
        path: "/liste-roles",
        name: "ListeRolePage",
        component: ListeRolePage,
      },
      {
        path: "/view-role/:id",
        name: "ViewRolePage",
        component: ViewRolePage,
      },
      {
        path: "/liste-journal-connexion",
        name: "ListeJournalConnexionPage",
        component: ListeJournalConnexionPage,
      },
      {
        path: "/liste-journal-operation",
        name: "ListeJournalOperationPage",
        component: ListeJournalOperationPage,
      },
      {
        path: "/ajouter-user",
        name: "AddUserPage",
        component: AddUserPage,
      },
      {
        path: "/modifier-user/:id",
        name: "EditUserPage",
        component: EditUserPage,
      },
      {
        path: "/liste-users",
        name: "ListeUserPage",
        component: ListeUserPage,
      },
      {
        path: "/statistiques",
        name: "StatistiquePage",
        component: StatistiquePage,
      },
      {
        path: "/recensement-usager",
        name: "RecensementUsager",
        component: RecensementUsager,
      },
      {
        path: "/recensement-form",
        name: "RecensementForm",
        component: RecensementForm,
      },
      {
        path: "/fiche-recensement",
        name: "FicheRecensementPage",
        component: FicheRecensementPage,
      },
      {
        path: "/profile",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/liste-verifications",
        name: "ListeVerification",
        component: ListeVerificationPage,
      },
      {
        path: "/liste-recensements",
        name: "ListeRecensement", 
        component: ListeRecensementPage,
      },
      {
        path: "/dashboard-recensement",
        name: "RecensementDashboard",
        component: RecensementDashboard,
      },
      {
        path: "/etat-usagers",
        name: "EtatUsagersPage",
        component: EtatUsagersPage,
      },
      {
        path: "/etat-places-arrieres",
        name: "EtatPlacesArrieresPage",
        component: EtatPlacesArrieresPage,
      },
      {
        path: "/ajouter-contrat",
        name: "AddContratPage",
        component: AddContratPage,
      },
      {
        path: "/liste-contrats",
        name: "ListeContratPage",
        component: ListeContratPage,
      },
      {
        path: "/mutation-contrat/:id",
        name: "MutationContratPage",
        component: MutationContratPage,
      },
      {
        path: "/liste-types-recette",
        name: "ListeTypeRecettePage",
        component: ListeTypeRecettePage,
      },
      {
        path: "/liste-marches",
        name: "ListeMarchePage",
        component: ListeMarchePage,
      },
      {
        path: "/liste-zones",
        name: "ListeZonePage",
        component: ListeZonePage,
      },
      {
        path: "/liste-secteurs-parametres",
        name: "ListeSecteurParametresPage",
        component: ListeSecteurParametresPage,
      },
      {
        path: "/liste-modes-paiement",
        name: "ListeModePaiementPage",
        component: ListeModePaiementPage,
      },
    ],
  },
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layouts/AuthLayout.vue"),
    children: [
      {
        path: '/login',
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/register",
        name: "RegisterPage",
        component: RegisterPage,
      },
      
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordPage",
        component: ResetPasswordPage,
      },
      {
        path: "/email-confirmation",
        name: "EmailConfirmationPage",
        component: EmailConfirmationPage,
      },
      {
        path: "/connected-accounts",
        name: "ConnectedAccountsPage",
        component: ConnectedAccountsPage,
      },
      {
        path: "/maintenance",
        name: "MaintenancePage",
        component: MaintenancePage,
      },
      {
        path: "/logout",
        name: "LogoutPage",
        component: LogoutPage,
      },
    ],
  },
 
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
];

const router = createRouter({
  history: createWebHashHistory(),
  //history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  // verify auth token before each page change
  //authStore.verifyAuth();
  
  // before page access check if page requires authentication
  if(to.meta.middleware == "auth") {
    ApiService.setHeader();
    if (authStore.isAuthenticated) {
      next();
    } else {
      next({ name: "LoginPage" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});


export default router;